<template>
	<div
		class="group z-30 flex h-full w-full flex-col justify-between gap-1 rounded-lg p-2 transition-all duration-300 ease-in-out hover:opacity-60"
		:class="borderClass"
	>
		<div class="flex flex-col items-start justify-start">
			<p
				v-if="type === 'content'"
				class="max-w-[90%] break-words text-[10px] uppercase text-slate-700 mb-1"
			>
				{{ contentType }}
			</p>

			<p
				v-html="title"
				class="max-w-[90%] line-clamp-3 text-left text-xs font-semibold transition-all duration-200"
				:class="type === 'content' ? 'text-slate-700' : 'text-blue'"
			></p>
		</div>
		<div class="flex justify-end items-end h-full">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="16"
				height="16"
				fill="none"
				viewBox="0 0 16 16"
				class="h-5 w-5"
				:stroke="borderAndArrowColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			>
				<path d="M4 8h8m0 0l-3-3m3 3l-3 3" />
			</svg>
		</div>
	</div>
</template>

<script lang="js" src="./SquareArrowButton.js"></script>
